<div>
  <ng-container [formGroup]="form">
    <div class="nz-block-input">
      <label>Keyword</label>
      <input
        nz-input
        placeholder="Keyword"
        formControlName="keyword"
        (blur)="onBlur('keyword')"
        (ngModelChange)="clearError()"
        nzSize="large"
        />
      </div>

      <div class="nz-block-input">
        <label>Location</label>
        <nz-select
          formControlName="location"
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Location"
          (ngModelChange)="clearError()"
          >
          @for (country of lookupCountries; track country) {
            <nz-option [nzLabel]="country"
              [nzValue]="country"
             />
          }
        </nz-select>
      </div>

      <div class="nz-block-input">
        <label>Category</label>
        <nz-select
          formControlName="category"
          nzShowSearch
          nzAllowClear
          nzMode="multiple"
          nzPlaceHolder="Category"
          [nzMaxTagCount]="1"
          [nzMaxTagPlaceholder]="tagPlaceHolder"
          (ngModelChange)="clearError()"
          >
          @for (category of lookupCategories; track category) {
            <nz-option [nzLabel]="category"
              [nzValue]="category"
             />
          }
        </nz-select>
        <ng-template #tagPlaceHolder let-selectedList
          >+ {{ selectedList.length }} <span class="more">more</span>
        </ng-template>
      </div>

      <div class="nz-block-input">
        <label>Alert Frequency</label>
        <mat-radio-group formControlName="isDaily" aria-label="Alert Frequency">
          <mat-radio-button value="true">Daily</mat-radio-button>
          <mat-radio-button value="false">Weekly</mat-radio-button>
        </mat-radio-group>
      </div>
    </ng-container>
    @if (hasFormError) {
      <div class="error-text">
        {{ errorMessage }}
      </div>
    }
    <div nz-row>
      <div nz-col nzXs="24" nzMd="24">
        <button
          nz-button
          nzType="primary"
          nzShape="round"
          nzSize="large"
          (click)="save()"
          >
          Save
        </button>
        <button
          nz-button
          nzType="default"
          nzShape="round"
          nzSize="large"
          (click)="cancel()"
          >
          Cancel
        </button>
      </div>
    </div>
  </div>
